// Responsive navigation: a bottom tab bar on mobile, a left rail on desktop (driven
// entirely by CSS media queries against .nav).

import { NavLink } from 'react-router-dom';
import { useAuth } from '../lib/auth';

const links = [
  { to: '/', label: 'Feed', icon: '📰', end: true },
  { to: '/sources', label: 'Sources', icon: '🌐', end: false },
  { to: '/settings', label: 'Settings', icon: '⚙️', end: false },
];

export function Nav() {
  const { user, logout } = useAuth();
  return (
    <nav className="nav">
      <div className="nav-brand">newsfeed</div>
      <ul className="nav-links">
        {links.map((l) => (
          <li key={l.to}>
            <NavLink to={l.to} end={l.end} className={({ isActive }) => (isActive ? 'active' : '')}>
              <span className="nav-icon" aria-hidden>
                {l.icon}
              </span>
              <span className="nav-label">{l.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
      <button className="nav-logout" onClick={logout} title={`Log out ${user?.username ?? ''}`}>
        <span className="nav-icon" aria-hidden>
          ⎋
        </span>
        <span className="nav-label">Log out</span>
      </button>
    </nav>
  );
}
